<section class="main-wrap inner-views dashboard-wrap lens-module" [ngClass]="{ 'menu-open in': !toggleClass }">
  <nav class="navbar navbar-expand-lg" id="desk-top-nav">
    <app-user-menu></app-user-menu>
    <div class="button-box">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="sr-only">Toggle Dropdown</span>
        <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
      </button>

      <div class="dropdown-menu">
        <app-menu></app-menu>
        <app-menu-alt></app-menu-alt>
      </div>
    </div>
  </nav>

  <div class="container-wrap">
    <div class="heading-container sidebar-container" id="menu">
      <div class="row">
        <div class="col">
          <app-logo></app-logo>
          <div class="button-box">
            <button class="btn btn-sm-menu" type="button" (click)="toggleClass = !toggleClass">
              <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
            </button>
          </div>

          <app-header></app-header>
        </div>
      </div>
    </div>

    <div class="content-container products-container single-product lens-module">
      <div class="row">
        <div class="col-md-6">
          <div class="lens-module-data">
            <app-product-data [tempCartEvents]="tempCartEventsSubject.asObservable()"></app-product-data>
          </div>
        </div>
        <div class="col-md-6">
          <div class="prod-col-in">
            <h2 class="prod-title">
              Lens Selection
            </h2>
            <div class="progress" style="height: 7px;">
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar active" role="progressbar" style="width: 25%;"></div>
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar active" role="progressbar" style="width: 25%;"></div>
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar" role="progressbar" style="width: 25%;"></div>
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar" role="progressbar" style="width: 25%;"></div>
            </div>

            <div class="clearfix"></div>
            <div class="col-md-12 module-non-prescription readers">
              <h3>Readers</h3>
              <p>Lenses with added magnification for seeing up close</p>
              <span class="border"></span>
              <h3>Please Select a Lens Strength</h3>
              <div class="readers-data">
                @for (l of lenses; track $index; let i = $index) {
                  <div class="col-md-3 lens-strength">
                    <button [ngClass]="{ 'selected-lens': l.isSelected }" class="btn lens" type="button" (click)="selectLens(l.lensId.toString())">{{l.strength}}</button>
                  </div>
                }
              </div>
            </div>
            <div class="col-md-12 module-nav next-step">
              <button class="btn product-btn gray-btn" (click)="back()" type="button">Back</button>
              <button class="btn product-btn gray-btn" (click)="_orderManagerService.verifyLensSelection(isEditMode)" type="button">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

